// plugins/toastPlugin.js
import Vue from "vue";
import ToastContainer from "../components/ToastContainer.vue";

let containerInstance = null;

export default {
  install(Vue) {
    if (!containerInstance) {
      const Container = Vue.extend(ToastContainer);
      containerInstance = new Container();
      containerInstance.$mount();
      document.body.appendChild(containerInstance.$el);
    }

    Vue.prototype.$toast = function ({ type = "primary", message = "", duration = 5000 }) {
      containerInstance.addToast({ type, message, duration });
    };

    // 兼容 Element UI 风格的 $message 调用（项目内已有 17 处 this.$message.error(...)，
    // 此前未定义导致这些分支全部静默失败，统一映射到现有 toast）
    const messageToToast = (type) => (message) => {
      containerInstance.addToast({ type, message: String(message), duration: 5000 });
    };
    Vue.prototype.$message = {
      error: messageToToast("danger"),
      warning: messageToToast("warning"),
      success: messageToToast("success"),
      info: messageToToast("info"),
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/toastPlugin.js